const variablesPlugin = (editor) => {
  /**
   * Object that is used to replace the variable string to be used
   * in the HTML view
   * @type {object}
   */
  const mapper = editor.getParam('variable_mapper', {});

  /**
   * define a list of variables that are allowed
   * if the variable is not in the list it will not be automatically converterd
   * by default no validation is done
   * @todo  make it possible to pass in a function to be used a callback for validation
   * @type {array}
   */
  const valid = editor.getParam('variable_valid', null);

  /**
   * Get custom variable class name
   * @type {string}
   */
  const className = editor.getParam('variable_class', 'variable');

  /**
   * Prefix and suffix to use to mark a variable
   * @type {string}
   */
  const prefix = editor.getParam('variable_prefix', '{');
  const suffix = editor.getParam('variable_suffix', '}');

  /**
   * RegExp is not stateless with '\g' so we return a new variable each call
   * @return {RegExp}
   */
  function getStringVariableRegex() {
    return new RegExp(
      prefix + '([a-zA-Z0-9._ \\u00C0-\\u017F]*)?' + suffix,
      'g',
    );
  }

  /**
   * check if a certain variable is valid
   * @param {string} name
   * @return {bool}
   */
  function isValid(name) {
    if (!valid || valid.length === 0) return true;

    const validString = '|' + valid.join('|') + '|';

    return validString.indexOf('|' + name + '|') > -1 ? true : false;
  }

  function getMappedValue(cleanValue) {
    if (typeof mapper === 'function') return mapper(cleanValue);

    return mapper.hasOwnProperty(cleanValue) ? mapper[cleanValue] : cleanValue;
  }

  /**
   * Strip variable to keep the plain variable string
   * @example "{test}" => "test"
   * @param {string} value
   * @return {string}
   */
  function cleanVariable(value) {
    return value.replace(/[^a-zA-Z0-9._\s\u00C0-\u017F]/g, '');
  }

  /**
   * convert a text variable "x" to a span with the needed
   * attributes to style it with CSS
   * @param  {string} value
   * @return {string}
   */
  function createHTMLVariable(value) {
    const cleanValue = cleanVariable(value);

    // check if variable is valid
    if (!isValid(cleanValue)) return value;

    const cleanMappedValue = getMappedValue(value);

    editor.fire('variableToHTML', {
      value: value,
      cleanValue: cleanValue,
    });

    const variable = prefix + cleanValue + suffix;
    return (
      '<span class="' +
      className +
      '" data-original-variable="' +
      variable +
      '" contenteditable="false">' +
      cleanMappedValue +
      '</span>'
    );
  }

  /**
   * convert variable strings into html elements
   * @return {void}
   */
  // let typingVariableText = '';

  function stringToHTML(e) {
    // let moveCursor = false;
    // if (e.key === prefix && typingVariableText === '') {
    //   typingVariableText = prefix;
    // } else if (typingVariableText) {
    //   if (e.key === suffix) {
    //     typingVariableText += suffix;
    //     if (getStringVariableRegex().test(typingVariableText)) {
    //       moveCursor = true;
    //     }
    //   } else {
    //     typingVariableText += e.key;
    //   }
    // } else {
    //   typingVariableText = '';
    // }

    let nodeList = [],
      nodeValue,
      node,
      div;

    // find nodes that contain a string variable
    tinymce.walk(
      editor.getBody(),
      function (n) {
        if (
          n.nodeType === 3 &&
          n.nodeValue &&
          getStringVariableRegex().test(n.nodeValue)
        ) {
          if (isVariable(n.parentNode)) return;
          nodeList.push(n);
        }
      },
      'childNodes',
    );

    // loop over all nodes that contain a string variable
    let lastNode = null;
    for (let i = 0; i < nodeList.length; i++) {
      let isLast = nodeList.length - 1 === i;
      nodeValue = nodeList[i].nodeValue.replace(
        getStringVariableRegex(),
        createHTMLVariable,
      );
      div = editor.dom.create('div', null, nodeValue);
      while ((node = div.lastChild)) {
        if (isLast && isVariable(node)) {
          lastNode = node;
        }
        editor.dom.insertAfter(node, nodeList[i]);

        // if (isVariable(node)) {
        //   placeCursorAfterNode(node);
        // }
      }

      editor.dom.remove(nodeList[i]);
    }
    // if (moveCursor) {
    //   typingVariableText = '';
    //   placeCursorAtEnd();
    // }
  }

  function placeCursorAfterNode(node) {
    const rng = editor.dom.createRng();
    rng.setStartAfter(node);
    rng.setEndAfter(node);
    editor.selection.setRng(rng);
    // editor.focus();
  }

  function placeCursorAtEnd() {
    const body = editor.getBody();
    const sel = editor.selection.getSel();
    const range = sel.getRangeAt(0);
    console.log(sel);
    // const lastNode = body.lastChild;
    // console.log({ lastNode });
    // // Check if the last node is not editable
    // if (lastNode && lastNode.lastChild.contentEditable === 'false') {
    //   const zeroWidthSpace = document.createTextNode('\u200B');
    //   console.log({ zeroWidthSpace });
    //   lastNode.insertBefore(zeroWidthSpace, lastNode.nextSibling);
    //   editor.selection.select(editor.getBody(), true);
    //   editor.selection.collapse(false);
    //   editor.focus();
    // }
  }

  /**
   * convert HTML variables back into their original string format
   * for example when a user opens source view
   * @return {void}
   */
  function htmlToString() {
    let nodeList = [],
      nodeValue,
      node,
      div;

    // find nodes that contain a HTML variable
    tinymce.walk(
      editor.getBody(),
      function (n) {
        if (n.nodeType === 1) {
          var original = n.getAttribute('data-original-variable');
          if (original !== null) {
            nodeList.push(n);
          }
        }
      },
      'childNodes',
    );

    // loop over all nodes that contain a HTML variable
    for (let i = 0; i < nodeList.length; i++) {
      nodeValue = nodeList[i].getAttribute('data-original-variable');
      div = editor.dom.create('div', null, nodeValue);
      while ((node = div.lastChild)) {
        editor.dom.insertAfter(node, nodeList[i]);
      }

      // remove HTML variable node
      // because we now have an text representation of the variable
      editor.dom.remove(nodeList[i]);
    }
  }

  /**
   * handle formatting the content of the editor based on
   * the current format. For example if a user switches to source view and back
   * @param  {object} e
   * @return {void}
   */
  function handleContentRerender(e) {
    return e.format === 'raw' ? stringToHTML(e) : htmlToString();
  }

  /**
   * insert a variable into the editor at the current cursor location
   * @param {string} value
   * @return {void}
   */
  function addVariable(value) {
    const htmlVariable = createHTMLVariable(value);
    editor.execCommand('mceInsertContent', false, htmlVariable);
  }

  function isVariable(element) {
    return (
      typeof element.getAttribute === 'function' &&
      element.hasAttribute('data-original-variable')
    );
  }

  /**
   * Trigger special event when user clicks on a variable
   * @return {void}
   */
  function handleClick(e) {
    const target = e.target;

    if (!isVariable(target)) return null;

    // put the cursor right after the variable
    if (e.target.nextSibling) {
      editor.selection.setCursorLocation(e.target.nextSibling, 0);
    } else {
      editor.selection.select(e.target);
      editor.selection.collapse();
    }

    // and trigger event if we want to do something special
    const value = target.getAttribute('data-original-variable');
    editor.fire('variableClick', {
      value: cleanVariable(value),
      target: target,
    });
  }

  editor.on('beforegetcontent', handleContentRerender);
  editor.on('init', stringToHTML);
  editor.on('getcontent', stringToHTML);
  // editor.on('click', handleClick);
  // editor.on('mousedown', preventDrag);
  // editor.on('keydown', keyDown);
  // editor.on('NodeChange', nodeChange);
  editor.on('nodechange', stringToHTML);

  // handle case when user type variable manually
  editor.on('keyup', stringToHTML);

  editor.addCommand('insertVariable', function (ui, value) {
    addVariable(value);
  });
};

export default variablesPlugin;
